"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { RiCloseLine } from "react-icons/ri";
import { Button } from "@/components/ui";
import AIBadge from "@/components/ui/ai-badge";
import { Dialog, DialogBody, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { useCommunication } from "@/contexts/chat-provider";
import { UserTiny } from "@/types/user";
import AICallConfig from "./ai-call";
import PatientDetails from "./patient-details";
export type CallPatient = Pick<UserTiny, "id" | "firstName" | "lastName" | "phoneNumber">;
interface CallModalProps {
  patient: CallPatient;
  children?: React.ReactNode;
  open?: boolean;
  setOpen?: (open: boolean) => void;
}
const CallModal: React.FC<CallModalProps> = t0 => {
  const $ = _c(34);
  const {
    patient,
    children,
    open,
    setOpen
  } = t0;
  const {
    startCall,
    activeCall
  } = useCommunication();
  const [isAICallSelected, setIsAICallSelected] = useState(false);
  let t1;
  if ($[0] !== patient || $[1] !== startCall) {
    t1 = () => {
      startCall(patient);
    };
    $[0] = patient;
    $[1] = startCall;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleStartCall = t1;
  let t2;
  if ($[3] !== children || $[4] !== setOpen) {
    t2 = children && <DialogTrigger asChild={true} onClick={() => setOpen?.(true)}>{children}</DialogTrigger>;
    $[3] = children;
    $[4] = setOpen;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = isAICallSelected ? "AI Call Configuration" : "Call Patient";
  let t4;
  if ($[6] !== t3) {
    t4 = <DialogTitle className="text-h3">{t3}</DialogTitle>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DialogClose asChild={true}><Button variant="ghost" className="p-1.5" aria-label="Close" icon={<RiCloseLine className="h-5 w-5 shrink-0" aria-hidden={true} />} /></DialogClose>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <DialogHeader><div className="flex items-center justify-between">{t4}{t5}</div></DialogHeader>;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setIsAICallSelected(false);
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isAICallSelected || $[13] !== patient) {
    t8 = <DialogBody><PatientDetails patient={patient} callOngoing={isAICallSelected} showBackButton={isAICallSelected} onBackClick={t7} /></DialogBody>;
    $[12] = isAICallSelected;
    $[13] = patient;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== activeCall || $[16] !== handleStartCall || $[17] !== isAICallSelected) {
    t9 = !isAICallSelected && <><DialogClose asChild={true}><Button variant="secondary" onClick={handleStartCall} disabled={!!activeCall} icon={FaPhoneAlt}>Call</Button></DialogClose><Button variant="secondary" onClick={() => setIsAICallSelected(true)} className="flex items-center" icon={<AIBadge />}>AI Call</Button></>;
    $[15] = activeCall;
    $[16] = handleStartCall;
    $[17] = isAICallSelected;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== isAICallSelected || $[20] !== patient) {
    t10 = isAICallSelected && <div className="w-full"><AICallConfig patientId={patient.id} onCallComplete={() => {
        setIsAICallSelected(false);
      }} onClose={() => {
        setIsAICallSelected(false);
      }} /></div>;
    $[19] = isAICallSelected;
    $[20] = patient;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t9) {
    t11 = <DialogFooter>{t9}{t10}</DialogFooter>;
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t6 || $[27] !== t8) {
    t12 = <DialogContent className="!overflow-visible">{t6}{t8}{t11}</DialogContent>;
    $[25] = t11;
    $[26] = t6;
    $[27] = t8;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== open || $[30] !== setOpen || $[31] !== t12 || $[32] !== t2) {
    t13 = <Dialog open={open} onOpenChange={setOpen}>{t2}{t12}</Dialog>;
    $[29] = open;
    $[30] = setOpen;
    $[31] = t12;
    $[32] = t2;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
};
export default CallModal;